import { useMemo } from 'react';
import { useLearningEvents } from './liveEventQueries';
import { getOrderedNextStepEventIds } from './nextStepWorkshopIds';

// `nextRegisteredSession` is set only while the registered session is still
// upcoming; once it passes the BE clears the field. If `attended` hasn't been
// set yet (no-show, BE attendance pipeline lag, etc.) the event re-surfaces
// as the next step on purpose — that's how we re-prompt the user to register
// for the next available time slot.
export const isEventCompleted = e => e.nextRegisteredSession !== undefined || e.attended;
export const useNextStepEvent = ({
  skip = false
} = {}) => {
  var _nextEvent$nextUpcomi;
  const orderedIds = useMemo(() => getOrderedNextStepEventIds(), []);
  const {
    learningEvents,
    learningEventsLoading,
    learningEventsError
  } = useLearningEvents({
    ids: orderedIds
  }, {
    skip: orderedIds.length === 0 || skip
  });
  const {
    totalWorkshops,
    registeredEventCount,
    nextEvent
  } = useMemo(() => {
    var _orderedEvents$find;
    const orderedEvents = orderedIds.map(id => learningEvents.find(e => e.id === id)).filter(e => e !== undefined && e.active && e.nextUpcomingEventSession !== undefined);
    return {
      totalWorkshops: orderedEvents.length,
      registeredEventCount: orderedEvents.filter(isEventCompleted).length,
      nextEvent: (_orderedEvents$find = orderedEvents.find(e => !isEventCompleted(e))) !== null && _orderedEvents$find !== void 0 ? _orderedEvents$find : null
    };
  }, [learningEvents, orderedIds]);
  const isAllRegistered = totalWorkshops > 0 && registeredEventCount >= totalWorkshops;
  const nextAvailableSession = (_nextEvent$nextUpcomi = nextEvent === null || nextEvent === void 0 ? void 0 : nextEvent.nextUpcomingEventSession) !== null && _nextEvent$nextUpcomi !== void 0 ? _nextEvent$nextUpcomi : null;
  return {
    orderedIds,
    nextEvent,
    nextAvailableSession,
    totalWorkshops,
    registeredEventCount,
    isAllRegistered,
    learningEventsLoading,
    learningEventsError
  };
};